import { render, staticRenderFns } from "./LinkButtonBlock.vue?vue&type=template&id=4c1487e8"
import script from "./LinkButtonBlock.vue?vue&type=script&lang=js"
export * from "./LinkButtonBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports